import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/Navbar';
import RoutesComponent from './RoutesComponent';

function App() {
  return (
    <Router>
      <Navbar />
      <RoutesComponent />
    </Router>
  );
};

export default App;

// import React from 'react';
// import './App.css';
// import BarChart from './components/BarChart';

// function App() {
//   // Sample data
//   const tourismData = [
//     { country: 'France', visitors: 89000000 },
//     { country: 'United States', visitors: 79400000 },
//     { country: 'Spain', visitors: 83000000 },
//     { country: 'India', visitors: 63000000 },
//     { country: 'Italy', visitors: 58000000 },
//     { country: 'Turkey', visitors: 45000000 },
//   ];

//   return (
//     <div className="App">
//       <BarChart data={tourismData} />
//     </div>
//   );
// }

// export default App;
